<template>
  <div>
    <div class="box">
      <vue-element-loading :active="isLoading" spinner="spinner" />
      <div class="field has-addons has-text-centered is-vcentered">
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getPrev()"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getNext()"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
        <h5 class="title is-5 ml-3 mt-2">{{ startDate + "～" + endDate }}</h5>
      </div>
      <div class="table-container mt-2">
        <table
          class="table narrower is-fullwidth table-container has-text-centered daily-report"
        >
          <thead>
            <tr class="daily-report">
              <th v-for="(day, index) in daysTitle" v-bind:key="index">
                {{ day }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(items, index) in aggrList"
              v-bind:key="index"
              class="daily-report"
            >
              <td>{{ index }}</td>
              <td v-for="(item, i) in items" v-bind:key="i" :class="item.color">
                {{ item.count }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import common from "@/imsr-common";
import { ref } from "vue";
import VueElementLoading from "vue-element-loading";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
export default {
  components: {
    VueElementLoading,
  },
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const router = useRoute();
    const aggrList = ref();
    const isLoading = ref(false);
    const baseDate = ref(null);
    const startDate = ref();
    const endDate = ref();
    const nextDate = ref();
    const prevDate = ref();
    const daysTitle = ref([]);
    const deviceList = ref([]);
    const formdate = ref();

    const getList = async () => {
      isLoading.value = true;
      try {
        const date = common.makeDate2(baseDate.value);
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          startDate: date.start + "00",
          endDate: date.end + "23",
        };
        startDate.value = date.startStr;
        endDate.value = date.endStr;
        nextDate.value = date.nextDate;
        prevDate.value = date.prevDate;
        const res = await imsr.imsrGetApi("/events/hour", params);
        let data = {};
        daysTitle.value = [t("devices.deviceId")];
        res.years.forEach(function(years) {
          years.months.forEach(function(month) {
            month.days.forEach(function(days) {
              daysTitle.value.push(days.day);
              days.hours.forEach(function(hours) {
                hours.devices.forEach(function(device) {
                  if (!data[device.deviceId]) {
                    data[device.deviceId] = [];
                  }
                  let i = days.day - 1;
                  if (!data[device.deviceId][i]) {
                    data[device.deviceId][i] = { count: 0 };
                  }
                  data[device.deviceId][i]["count"] += device.count;
                  if (data[device.deviceId][i]["count"] > 4) {
                    data[device.deviceId][i]["color"] = "imsr-danger";
                  } else if (data[device.deviceId][i]["count"] > 0) {
                    data[device.deviceId][i]["color"] = "imsr-warning";
                  }
                });
              });
            });
          });
        });
        aggrList.value = data;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
      isLoading.value = false;
    };
    getList();

    const getDevice = async () => {
      try {
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
        };
        const res = await imsr.imsrGetApi("/devices/list", params);
        let data = [];
        res.forEach(function(val) {
          data[val.deviceId] = {
            name: val.deviceLocate,
            shotName: val.deviceLocate.substring(0, 6),
          };
        });
        deviceList.value = data;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getDevice();

    const doSearch = () => {
      baseDate.value = formdate.value;
      getList();
    };

    const getPrev = () => {
      baseDate.value = prevDate.value;
      getList();
    };

    const getNext = () => {
      baseDate.value = nextDate.value;
      getList();
    };

    return {
      aggrList,
      isLoading,
      startDate,
      endDate,
      getPrev,
      getNext,
      deviceList,
      formdate,
      doSearch,
      daysTitle,
    };
  },
};
</script>
<style>
.has-event {
  padding: 0;
}
.daily-report {
  font-size: 85%;
}
.imsr-warning {
  background-color: rgb(255, 246, 97);
}
.imsr-danger {
  background-color: rgb(255, 137, 127);
}
</style>
